import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AccountComponent } from './account.component';
import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ConfirmEmailComponent } from './components/confirm-email/confirm-email.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SignupSuccessComponent } from './components/signup-success/signup-success.component';
import { ResendConfirmLinkComponent } from './components/resend-confirm-link/resend-confirm-link.component';

const routes: Routes = [
  { 
    path: '',
    data: { breadcrumb: "Account" },
    component: AccountComponent,
    children:[
      {
        path: 'login',
        data: { breadcrumb: 'Log In' },
        component: LoginComponent
      },
      {
        path: 'signup',
        component: SignupComponent,
        data: { breadcrumb: "Sign Up" }
      },
      {
        path: 'signup-success',
        component: SignupSuccessComponent,
        data: { breadcrumb: "Sign Up" }
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        data: { breadcrumb: "Forgot Password" }
      },
      {
        path: 'resend-confirm-link',
        component: ResendConfirmLinkComponent,
        data: { breadcrumb: "Resend Confirm Link" }
      },
      {
        path: 'confirm-email',
        component: ConfirmEmailComponent,
        data: { breadcrumb: "Confirm Email" }
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        data: { breadcrumb: "Reset Password" }
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }
